import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Download, Mail, Copy, Check } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function MediaPage() {
  const [copied, setCopied] = useState(false);
  const boilerplate = `Elizabeth Guzmán is a social worker, union member, and immigrant who came to America as a young single mother with $300 in her pocket. She worked her way through Northern Virginia Community College and earned two master's degrees. In 2017, she made history as the first Latina immigrant elected to the Virginia General Assembly. During her tenure, she introduced over 100 bills, led the fight for paid sick days, passed historic legislation lifting Virginia's ban on public sector collective bargaining, expanded Medicaid, and banned ICE from cooperating with local law enforcement. She is now running for Congress in Virginia's 7th District.`;
  const handleCopy = () => {
    navigator.clipboard.writeText(boilerplate);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen bg-warmgray font-sans text-navy selection:bg-red selection:text-white" data-id="element-487">
      <Navbar alwaysSolid={true} data-id="element-488" />

      {/* Hero Section */}
      <section className="pt-32 pb-20 md:pt-40 md:pb-28 bg-navy text-white relative overflow-hidden" data-id="element-489">
        <div className="absolute inset-0 opacity-10" data-id="element-490">
          <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/9c4e7vYPBAjAafuRJRjWho/Elizabeth_Guzman-Small_group_talking-30.jpg')] bg-cover bg-center mix-blend-luminosity" data-id="element-491" />
        </div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-492">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-3xl" data-id="element-493">
            <div className="flex items-center gap-4 mb-6" data-id="element-494">
              <div className="h-[1px] w-12 bg-red" data-id="element-495"></div>
              <span className="text-red font-bold tracking-widest uppercase text-sm" data-id="element-496">
                Press & Media
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-serif mb-6 leading-tight" data-id="element-497">
              Media Toolkit
            </h1>
            <p className="text-xl text-white/80 font-light leading-relaxed max-w-2xl" data-id="element-498">
              Official resources, high-resolution photos, and information for
              members of the press and media covering Elizabeth Guzmán's
              campaign for Virginia's 7th Congressional District.
            </p>
          </motion.div>
        </div>
      </section>

      <main className="py-20 md:py-32" data-id="element-499">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-24" data-id="element-500">
          {/* Contact Section */}
          <section data-id="element-501">
            <div className="bg-white p-8 md:p-12 rounded-sm shadow-xl border-t-4 border-red flex flex-col md:flex-row items-start md:items-center justify-between gap-8" data-id="element-502">
              <div data-id="element-503">
                <h2 className="text-2xl font-serif text-navy mb-2" data-id="element-504">
                  Press Inquiries
                </h2>
                <p className="text-navy/70" data-id="element-505">
                  For all media requests, interviews, and press inquiries.
                </p>
              </div>
              <a href="mailto:gabe@guzmanforvirginia.com" className="flex items-center gap-3 bg-navy hover:bg-sky text-white px-8 py-4 rounded-sm font-bold tracking-widest uppercase text-sm transition-colors whitespace-nowrap" data-id="element-506">
                <Mail size={18} data-id="element-507" />
                Contact Press Team
              </a>
            </div>
          </section>

          {/* Photos Section */}
          <section data-id="element-508">
            <div className="flex items-center gap-4 mb-8" data-id="element-509">
              <h2 className="text-3xl font-serif text-navy" data-id="element-510">
                High-Resolution Photos
              </h2>
              <div className="h-[1px] flex-1 bg-navy/10" data-id="element-511"></div>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-512">
              <div className="group relative rounded-sm overflow-hidden shadow-md" data-id="element-513">
                <img src="https://cdn.magicpatterns.com/uploads/3xZcMwQFmnRZxTkF1qp5Ma/Elizabeth_Guzman-Headshots-51.jpg" alt="Elizabeth Guzmán Headshot" className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-514" />
                <div className="absolute inset-0 bg-navy/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-515">
                  <a href="https://cdn.magicpatterns.com/uploads/3xZcMwQFmnRZxTkF1qp5Ma/Elizabeth_Guzman-Headshots-51.jpg" download target="_blank" rel="noreferrer" className="flex items-center gap-2 bg-white text-navy px-6 py-3 rounded-sm font-bold uppercase tracking-widest text-sm hover:bg-sky hover:text-white transition-colors" data-id="element-516">
                    <Download size={16} data-id="element-517" />
                    Download
                  </a>
                </div>
              </div>
              <div className="group relative rounded-sm overflow-hidden shadow-md" data-id="element-518">
                <img src="https://cdn.magicpatterns.com/uploads/vWZZYsZpHHZ6EnuE5Pnmee/EG_homepage-edit.jpg" alt="Elizabeth Guzmán with community" className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-519" />
                <div className="absolute inset-0 bg-navy/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-520">
                  <a href="https://cdn.magicpatterns.com/uploads/vWZZYsZpHHZ6EnuE5Pnmee/EG_homepage-edit.jpg" download target="_blank" rel="noreferrer" className="flex items-center gap-2 bg-white text-navy px-6 py-3 rounded-sm font-bold uppercase tracking-widest text-sm hover:bg-sky hover:text-white transition-colors" data-id="element-521">
                    <Download size={16} data-id="element-522" />
                    Download
                  </a>
                </div>
              </div>
              <div className="group relative rounded-sm overflow-hidden shadow-md" data-id="element-523">
                <img src="https://cdn.magicpatterns.com/uploads/fESAeq4mYrNq6RCnXZnFoV/guzman-portrait.jpg" alt="Elizabeth Guzmán portrait outdoors" className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-524" />
                <div className="absolute inset-0 bg-navy/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-525">
                  <a href="https://cdn.magicpatterns.com/uploads/fESAeq4mYrNq6RCnXZnFoV/guzman-portrait.jpg" download target="_blank" rel="noreferrer" className="flex items-center gap-2 bg-white text-navy px-6 py-3 rounded-sm font-bold uppercase tracking-widest text-sm hover:bg-sky hover:text-white transition-colors" data-id="element-526">
                    <Download size={16} data-id="element-527" />
                    Download
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Boilerplate Section */}
          <section data-id="element-528">
            <div className="flex items-center gap-4 mb-8" data-id="element-529">
              <h2 className="text-3xl font-serif text-navy" data-id="element-530">
                About Elizabeth (Boilerplate)
              </h2>
              <div className="h-[1px] flex-1 bg-navy/10" data-id="element-531"></div>
            </div>
            <div className="bg-white p-8 md:p-12 rounded-sm shadow-md border border-navy/5 relative group" data-id="element-532">
              <button onClick={handleCopy} className="absolute top-6 right-6 p-3 bg-warmgray hover:bg-navy hover:text-white text-navy/60 rounded-sm transition-colors flex items-center gap-2" aria-label="Copy boilerplate text" data-id="element-533">
                {copied ? <Check size={18} className="text-green-600" data-id="element-534" /> : <Copy size={18} data-id="element-535" />}
                <span className="text-xs font-bold uppercase tracking-widest hidden md:inline-block" data-id="element-536">
                  {copied ? 'Copied!' : 'Copy Text'}
                </span>
              </button>
              <h3 className="text-lg font-bold text-navy mb-4 pr-32" data-id="element-537">
                Short Bio (100 words)
              </h3>
              <p className="text-navy/80 leading-relaxed text-lg" data-id="element-538">
                {boilerplate}
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-539" />
    </div>;
}